import { Colors, Lightning } from '@lightningjs/sdk';
import ExpandingButton, {
  ExpandingButtonTemplateSpec,
} from 'components/common/buttons/ExpandingButton';
import { getFontFaceFromStyle, TextStyles } from 'support/textUtils';

export interface ExpandingIconButtonTemplateSpec
  extends ExpandingButtonTemplateSpec {
  selected: boolean;
  fontStyle: TextStyles;

  Underline: object;
}

const IMAGE_WIDTH = 27;
const IMAGE_HEIGHT = 27;

const COLLAPSED_RADIUS = 0;
const EXPANDED_RADIUS = 24;

export default class ExpandingIconButton
  extends ExpandingButton<ExpandingIconButtonTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<ExpandingIconButtonTemplateSpec>
{
  private _fontStyle: TextStyles = 'regular';
  private _selected = false;
  private _Underline = this.getByRef('Underline');

  protected override _imageWidth = IMAGE_WIDTH;
  protected override _imageHeight = IMAGE_HEIGHT;

  get selected() {
    return this._selected;
  }

  set selected(value) {
    this._selected = value;
  }

  get fontStyle() {
    return this._fontStyle;
  }

  set fontStyle(value) {
    this._fontStyle = value;
  }

  static override _template(): Lightning.Component.Template<ExpandingIconButtonTemplateSpec> {
    return {
      ...super._template(),
      Underline: {
        flexItem: false,
        alpha: 0,
        x: 0,
        y: 40,
        w: IMAGE_WIDTH,
        h: 5,
        rect: true,
        color: Colors('appAccent').get(),
      },
    };
  }

  override _init() {
    this._Underline?.patch({ alpha: this.selected ? 1 : 0 });
    this._EndIcon.patch({ visible: false });

    if (this._Label.text) {
      this._Label.text.fontFace = getFontFaceFromStyle(this.fontStyle);
    }

    this.radius = COLLAPSED_RADIUS;

    super._init();
  }

  protected override onExpand() {
    super.onExpand();
    this.radius = EXPANDED_RADIUS;
  }

  protected override onCollapse() {
    super.onCollapse();
    this.radius = COLLAPSED_RADIUS;
  }

  protected override getIconMarginLeft(expanded: boolean): number {
    return expanded ? this.margin : 0;
  }

  protected override setMargin(expanded: boolean) {
    super.setMargin(expanded);
    const iconMargin = this.getIconMarginLeft(expanded);
    this._Underline?.patch({ x: iconMargin });
  }
}
